import { useEffect, useMemo, useState } from "react";
import {
  MobileTournamentInfoContent,
  MobileTournamentInfoItem,
  MobileTournamentInfoWrapper,
} from "./style";
import { formatDateWithDay } from "../../../../../../utils/date";
import { TournamentResponse } from "../../../../../../api/tournament";
import { TimerInfoState } from "../../../../../timer-controller";
import { calculateTimes } from "../../../../../timer-controller/hooks/timer";
import { StructuresResponse } from "../../../../hook/useEditTournament";

const MobileTournamentMoreInfo = ({
  tournament,
}: {
  tournament: TournamentResponse | null;
}) => {
  const [timeInfo, setTimeInfo] = useState<TimerInfoState>({
    elapsedTimeMs: null as number | null,
    elapsedTime: "00:00:00" as string | null,
    currentLevel: null as StructuresResponse | null,
    remainingTimeInCurrentLevel: "00:00",
    timeUntilNextBreak: "00:00" as string | null,
    elapsedTimeInCurrentLevel: "00분00초" as string | null,
    elapsedTimeInCurrentLevelMs: null as number | null,
    remainingTimeInCurrentLevelMs: null as number | null,
  });

  const getTime = (value: string) => {
    const date = new Date(value);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const isPM = hours >= 12;

    hours = hours % 12;
    if (hours === 0) hours = 12;

    return `${isPM ? "오후" : "오전"} ${hours}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  useEffect(() => {
    if (!tournament?.timerDto || !tournament?.structure) return;
    const updatedTimeInfo = calculateTimes(
      tournament?.timerDto,
      tournament?.structure,
      null,
    );
    setTimeInfo(updatedTimeInfo);
  }, [tournament]);

  const infoList = useMemo(() => {
    if (!tournament) return;

    const state =
      timeInfo?.elapsedTimeMs && timeInfo?.elapsedTimeMs < 0
        ? "진행예정"
        : tournament.isEnd
          ? "종료"
          : "진행중";

    const totalValue = tournament.moneyInChip.reduce(
      (sum, item) => sum + item.point,
      0,
    );

    const duration = tournament.structure.map((item) => {
      if (item.level !== null) return item.time;
      return 0;
    });
    const durationArr = duration.reduce<number[]>((acc, curr) => {
      if (!acc.includes(curr) && curr !== 0) acc.push(curr);
      return acc.sort((a, b) => b - a);
    }, []);

    return [
      { name: "상태", value: state },
      { name: "토탈 프라이즈", value: `${totalValue?.toLocaleString()}` },
      { name: "날짜", value: formatDateWithDay(tournament.startDate) },
      { name: "시간", value: getTime(tournament.startDate) },
      {
        name: "바이인",
        value: `${(tournament.buyIn || 0)?.toLocaleString()}`,
      },
      { name: "레지 마감", value: `${tournament.registerDeadlineLevel}LV` },
      { name: "스타팅 칩", value: tournament.buyInChip?.toLocaleString() },
      { name: "리엔트리 칩", value: tournament.reBuyInChip?.toLocaleString() },
      { name: "기준 엔트리", value: `${tournament.entry}` },
      { name: "듀레이션", value: `${durationArr.join("/")}분` },
    ];
  }, [tournament, timeInfo]);

  return (
    <MobileTournamentInfoWrapper>
      <div className="title">{tournament?.title}</div>
      <MobileTournamentInfoContent>
        {infoList?.map((item, index) => (
          <MobileTournamentInfoItem key={index}>
            <div className="name">{item.name}</div>
            <div className="value">{item.value}</div>
          </MobileTournamentInfoItem>
        ))}
      </MobileTournamentInfoContent>
    </MobileTournamentInfoWrapper>
  );
};

export default MobileTournamentMoreInfo;
